import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { OMOperator      } from 'src/app/beans/operator/operator.bean';

@Injectable
({
  providedIn: 'root'
})

export class OperatorHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async getOperatorList( token: string, organizationId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( organizationId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID,
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().getOperatorList( token, organizationId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getOperatorLevel( token: string, organizationId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( organizationId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID,
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().getOperatorLevel( token, organizationId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async assignableList( token: string, orgId: number, deviceId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( orgId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID,
            )
            return undefined
        }

        if (!this._utils.checker().isValidId( deviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_DEVICE_ID,
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().assignableList( token, orgId, deviceId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async assignedList( token: string, deviceId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( deviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_DEVICE_ID,
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().assignedList( token, deviceId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getOperatorCounter( token: string, operatorId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().getOperatorCounter( token, operatorId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async getDetail( token: string, operatorId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().getDetail( token, operatorId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async create( token: string, organizationId: number, data: OMOperator )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( organizationId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidText( data.loginName ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPE_NAME
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().create( token, organizationId, JSON.stringify(data)).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update( token: string, organizationId: number, operatorId: number, data: OMOperator )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( organizationId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidText( data.loginName ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPE_NAME
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().update( token, organizationId, operatorId, JSON.stringify(data)).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )
            return response
          }
          
        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async assign( token: string, deviceId: number, operatorId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING                , 
            NotifierMessage.INVALID_PASSWORD,
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( deviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_DEVICE_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().assign( token, deviceId, operatorId).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async unassign( token: string, deviceId: number, operatorId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( deviceId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_DEVICE_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().unassign( token, deviceId, operatorId).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async resetPassword( token: string, organizationId: number, operatorId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show
          ( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        }

        if (!this._utils.checker().isValidId( organizationId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_ORG_ID
            )
            return undefined
        }

        if (!this._utils.checker().isValidId( operatorId ))
        {
            this._notifier.show
            ( 
              Notifier.WARNING, 
              NotifierMessage.INVALID_OPERATOR_ID
            )
            return undefined
        }

        try
        {
          const response = await this._request.operator().resetPassword( token, organizationId, operatorId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )

            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

